var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomFieldList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5v15M13.5 6.75h8.25a.75.75 0 01.75.75v9a.75.75 0 01-.75.75H13.5M10.5 17.25H2.25a.75.75 0 01-.75-.75v-9a.75.75 0 01.75-.75h8.25M4.688 10.5h2.625M6 10.5v3.375",
    stroke: "#008996",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCustomFieldList;